import { ChangeDetectionStrategy, Component, inject, LOCALE_ID, OnDestroy, resource } from "@angular/core";
import { NgOptimizedImage } from "@angular/common";

import { HostResizeDirective } from "../../host-width-change-listener.directive";
import { IClientForm } from "@in2/models";
import { AppService } from "../../app.service";

// declare let ViewTimeline: any
@Component({
    selector: "in2-client-logos",
    imports: [NgOptimizedImage],
    templateUrl: "./client-logos.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ["./client-logos.component.scss"],
    host: {
        class: "py-6 flex flex-col px-0",
    },
})
export class ClientLogosComponent extends HostResizeDirective implements OnDestroy {
    private readonly contentService = inject(AppService);
    private readonly locale = inject(LOCALE_ID);

    clientsResource = resource({
        loader: () => {
            return this.contentService
                .fetchJsonAsset<IClientForm[]>(`client?lang=${this.locale}&select=name,image.path,lang&status=published&sort_by=order,desc`)
                .then((res) => res.data ?? [])
                .then((res) => res.map((client) => ({ ...client, img: { src: client.image?.[0]?.path } })));
        },
    });

    // private _setViewData(width: number) {
    //     if (this.clients.length === 0) return;

    //     const x = Math.floor(width / 100);
    //     const fits = Math.max(1, Math.floor((width - (x - 1) * 16) / 100));
    //     const rows = Math.max(2, Math.min(4, Math.floor(this.clients.length / fits)));
    //     const numInRow = Math.ceil(this.clients.length / rows);
    //     const items = new Array(rows).fill(0).map((_, i) => this.clients.slice(i * numInRow, i * numInRow + numInRow));
    //     this.viewData.set(items);
    // }
}
